<script lang="ts" setup>
import { provide, ref, toRef } from 'vue'
import { bookConfig as config } from './configs/vowpath'
import { useBookPage } from './composables/useBookPage'
import BookPageVowpath from './components/BookPage.vowpath.vue'
import { bannerShow, useBannerShow } from '@/composables/useBannerShow'

const props = defineProps<{
  contentId: string
}>()

const BookPage = BookPageVowpath

// 🔥 使用 composable 管理页面逻辑
const {
  book,
  coverUrl,
  skeleton,
  popupTOC,
  currentProgressChapterId,
  unlockedChapterIds,
  isCompleted,
  isInShelf,
  onBookshelf,
  onRead,
  openPopupTOC,
  gotoTags,
  gotoBack,
  onCoverLoaded,
  onPreloadComplete,
  onResetConfirm,
} = useBookPage(toRef(props, 'contentId'), config)

// 容器引用（用于滚动等）
const containerRef = ref<HTMLElement | null>(null)
provide('containerRef', containerRef)

// 初始化 banner 显示逻辑
useBannerShow()
</script>

<template>
  <div>
    <!-- Loading 状态 -->
    <div v-if="skeleton">
      <div class="pt-20vh flex justify-center">
        <BasicSpinner class="mx-auto" />
      </div>
      <p class="mt-4 text-center font-bold text-n-text-1">
        {{ config.texts.loading }}
      </p>
    </div>

    <!-- 书籍不存在 -->
    <div v-else-if="!book">
      <BizBlockEmpty :title="config.texts.booksNotExist" />
    </div>

    <!-- 主内容 -->
    <div v-else ref="containerRef" class="h-100dvh bg-n-bg-global overflow-hidden">
      <!-- 下载 Banner -->
      <BizDownloadApp
        v-if="bannerShow"
        :id="contentId"
        position="fixed"
        class="fixed top-0 w-full z-9999"
        from="book"
      />

      <!-- 🔥 品牌专属页面组件（封面 + 内容） -->
      <BookPage
        :popup-t-o-c="popupTOC"
        :book="book"
        :config="config"
        :cover-url="coverUrl"
        :banner-show="bannerShow"
        :current-progress-chapter-id="currentProgressChapterId"
        :unlocked-chapter-ids="unlockedChapterIds"
        :is-completed="isCompleted"
        :is-in-shelf="isInShelf"
        @update:popup-t-o-c="popupTOC = $event"
        @goto-tags="gotoTags"
        @open-toc="openPopupTOC"
        @bookshelf="onBookshelf"
        @read="onRead"
        @back="gotoBack"
        @cover-loaded="onCoverLoaded"
        @preload-complete="onPreloadComplete"
        @reset-confirm="onResetConfirm"
      />
    </div>
  </div>
</template>
